module.exports = __webpack_public_path__ + "static/img/p_icon1.3e6a168a.png";